import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getAllServices, getServiceById } from "../../Api";

const Details = ({ language = "EN" }) => {
  const { id } = useParams();

  const [service, setService] = useState(null);
  const [servicesList, setServicesList] = useState([]);
  const [loading, setLoading] = useState(true);

  const langKey = language === "CN" ? "zh" : "en";
  const lang = language === "CN" ? "zh" : "en";

  const text = {

    en: {
      loading: "Loading Service...",
      notfound: "Service Not Found",
      home: "Home",
      services: "Services",
      about: "About",
      ourServices: "Our Services",
      contact: "Get In Touch",
    },

    zh: {
      loading: "加载中...",
      notfound: "未找到服务",
      home: "首页",
      services: "服务",
      about: "关于",
      ourServices: "我们的服务",
      contact: "联系我们",
    },

  };

  useEffect(() => {
    setLoading(true);

    Promise.all([getServiceById(id), getAllServices()])
      .then(([singleRes, listRes]) => {
        if (singleRes.data.success) {
          setService(singleRes.data.data);
        }

        if (listRes.data.success) {
          setServicesList(listRes.data.data);
        }
      })
      .catch((err) => {
        console.error("Service Fetch Error:", err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="text-center py-10 text-xl font-semibold">
        {text[lang].loading}
      </div>
    );
  }

  if (!service) {
    return (
      <div className="text-center py-10 text-red-500 text-xl">
        {text[lang].notfound}
      </div>
    );
  }

  return (
    <>
      {/* ===================== STATIC BANNER ===================== */}
      <section className="relative h-[250px] md:h-[400px] flex items-center justify-center text-white overflow-hidden">

        <img
          src="/assets/images/successful-businessman-overlooking-city-skyline-with-stock-charts.jpg"
          alt="Services Banner"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/30"></div>

        <div className="relative text-center px-4">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            {service.title?.[langKey]}
          </h1>

          <div className="bg-[#c69c6d] px-6 py-2 text-sm inline-block">
            <Link to="/" className="hover:underline">{text[lang].home}</Link> →
            <Link to="/services" className="mx-2 hover:underline">{text[lang].services}</Link> →
            <span>{service.title?.[langKey]}</span>
          </div>
        </div>
      </section>


      {/* ===================== CONTENT ===================== */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-[1320px] mx-auto px-4 grid lg:grid-cols-3 gap-12">

          {/* LEFT CONTENT */}
         <div className="lg:col-span-2">

  <img
    src={`${process.env.REACT_APP_API_URL}/${service.image?.replace(/\\/g, "/")}`}
    alt={service.title?.[langKey]}
    className="w-full h-[220px] md:h-[320px] lg:h-[420px] object-cover object-top mb-8"
  />
            <h2 className="text-3xl font-semibold text-[#154059] mb-6">
              {text[lang].about} {service.title?.[langKey]}
            </h2>

            {service.content?.[langKey]?.map((para, index) => (
              <p key={index} className="text-gray-600 mb-6 leading-relaxed">
                {para}
              </p>
            ))}
          </div>


          {/* RIGHT SIDEBAR */}
          <div>
            <div className="bg-white shadow-lg p-8 sticky top-28">

              <h3 className="text-xl font-semibold text-[#154059] mb-6">
                {text[lang].ourServices}
              </h3>

              <ul className="space-y-4">
                {servicesList.map((item) => (
                  <li key={item._id}>
                    <Link
                      to={`/services/${item._id}`}
                      className={`flex justify-between items-center px-5 py-3 transition ${
                        id === item._id
                          ? "bg-[#c69c6d] text-white"
                          : "bg-gray-100 hover:bg-[#c69c6d] hover:text-white"
                      }`}
                    >
                      <span>{item.title?.[langKey]}</span>
                      <span>→</span>
                    </Link>
                  </li>
                ))}
              </ul>

              <Link
                to="/contact"
                className="block mt-8 bg-[#154059] text-white text-center py-3 hover:bg-[#0f2d40] transition"
              >
                {text[lang].contact}
              </Link>

            </div>
          </div>

        </div>
      </section>
    </>
  );
};

export default Details;